import FeaturedServicesBlock from '@/blocks/FeaturedServicesBlock';
import HomeSliderBlock from '@/blocks/HomeSliderBlock';
import MissionVisionBlock from '@/blocks/MissionVisionBlock';
import OurClientsBlock from '@/blocks/OurClientsBlock';
import OurCompaniesBlock from '@/blocks/OurCompaniesBlock';
import OurCompanyBlock from '@/blocks/OurCompanyBlock';
import { REVALIDATE_TIME_IN_SEC } from '@/constants/env';
import homepage from '@/graphql/queries/homepage';
import mainLayout from '@/graphql/queries/mainLayout';
import FullWidthLayout from '@/layouts/FullWidthLayout';
import graphql from '@/lib/graphql';

export default function HomePage({ mainLayout, page, clients, companies }) {
  const attributes = page?.attributes || {};
  const contentSection = attributes.contentSection || [];
  const metaData = attributes.metaData || {};
  return (
    <FullWidthLayout mainLayout={mainLayout} metaData={metaData}>
      {contentSection[0]?.slides ? <HomeSliderBlock slides={contentSection[0].slides} /> : null}
      {contentSection[1]?.services ? (
        <FeaturedServicesBlock services={contentSection[1].services} />
      ) : null}
      {contentSection[2] ? <OurCompanyBlock data={contentSection[2]} /> : null}
      {contentSection[3] ? <OurCompaniesBlock data={contentSection[3]} /> : null}
      {contentSection[4] ? <MissionVisionBlock data={contentSection[4]} /> : null}
      <OurClientsBlock clients={clients || []} companies={companies || []} />
    </FullWidthLayout>
  );
}

export async function getStaticProps() {
  try {
    const { data: mainLayoutData } = await graphql(mainLayout);
    const { data: pageData } = await graphql(homepage);

    return {
      props: {
        mainLayout: mainLayoutData?.mainLayout?.data || { attributes: {} },
        page: pageData?.page?.data || { attributes: {} },
        clients: pageData?.clients?.data || [],
        companies: pageData?.companies?.data || [],
      },
      revalidate: parseInt(REVALIDATE_TIME_IN_SEC) || 60, // In seconds
    };
  } catch (_err) {
    return {
      props: {
        mainLayout: { attributes: {} },
        page: { attributes: {} },
        clients: [],
        companies: [],
      },
      revalidate: parseInt(REVALIDATE_TIME_IN_SEC) || 60,
    };
  }
}
